<template>
  <v-snackbar
    class="mysnackbar"
    v-model="showSnackbar"
    :color="color"
    :timeout="timeout">
    <span class="message">{{ text }} </span>
    <v-btn
      dark
      flat
      @click="showSnackbar = false">
      HIDE
    </v-btn>
  </v-snackbar>
</template>

<script>
    export default {
        name: 'snackbar',
        props: {
            show: false,
            text: false,
            timeout: false,
            color: false,
        },
        data() {
            return {
                showSnackbar: this.show
            }
        },
        watch: {
            show(newVal) {
                this.showSnackbar = newVal;
            },
            showSnackbar(newVal) {
                this.$store.commit('setSnackbarVisible', newVal);
            }
        }
    }
</script>

<style scoped>
  .message {
    font-size: 12px;
  }
  .mysnackbar {
    z-index: 9999;
  }
</style>



// WEBPACK FOOTER //
// src/components/widgets/snackbar.vue